import React, { useContext, useEffect, useState, useRef } from "react";
import { MyContext } from "../../MyContextApi";
import { Link } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import TextAnalysisTable from "../UserLevel/TextAnalysisTable";
import TextAnalysisTableNews from "../UserLevel/TextAnalysisTableNews";
import SwipeableTemporaryDrawer from "./TopDrawer";
import apiRequestFunction from "../../API/SendAsync";
import FilterListIcon from "@mui/icons-material/FilterList";
import "./../../styles/App.css";
import "./../../styles/Multiselect.css";
import "./../../styles/NavBar.css";
import "./../../styles/Loader.css";
import { useParams, useNavigate } from "react-router-dom";
import nodata from "../../images/nodata2.png";
import ImageAnalysisTable from "../UserLevel/ImageAnalysisTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faYoutube,
  faInstagram,
  faTiktok,
  faSquareXTwitter,
  faGolang,
  // faThreads,
  faSquareThreads,
  faRedditSquare,
} from "@fortawesome/free-brands-svg-icons"; // Import the icons
import ReactProSidebar from "../Admin/Dashboard/ReactProSidebar";
import NavBar from "../Admin/Dashboard/NavBar";
import FakeNewsDataGrid from "../UserLevel/DataGrid";
import SentimentAnalysisTable from "../UserLevel/SentimentAnalysisTable";
const ReportNav = () => {
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/previewreport");
  };

  //
  const param = useParams();
  //

  const {
    toggleButton,
    settoggleButton,
    serverresponse,
    responseCount,
    selectedPlatforms,
    selectedSections,
    selectedLanguages,
    selectedSentiment,
    selectedIntensity,
    selectedContent,
    fromDateTimeFormatted,
    toDateTimeFormatted,
    apiSelect,
    loading,
    applyValue,
  } = useContext(MyContext);
  //
  const tableRef = useRef(null); // Define the tableRef

  const handleSidebar = () => {
    settoggleButton(!toggleButton);
  };

  // Re-render component when serverresponse changes
  useEffect(() => {
    if (!loading && serverresponse) {
      //
    }
  }, [serverresponse, loading]);
  // console.log(serverresponse.status)
  //

  return (
    <>
      <NavBar />

      <SwipeableTemporaryDrawer />
      <main
        className="report-main"
        style={{
          overflow: "auto",
          scrollbarWidth: "none",
        }}
      >
        <div
          id="report-details"
          style={{
            paddingTop: "17px",
            paddingLeft: "40px",
            paddingRight: "40px",
            marginTop: "-5px",
            paddingBottom: "22px",
          }}
        >
          <div className="display-count">
            {responseCount > 0 && (
              <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                <strong>
                  <span style={{ color: "#024CAA" }}>Total Records:</span> 
                  {responseCount}
                </strong>
              </span>
            )}
            {apiSelect && apiSelect.value === "api/filter" ? (
              <>
                {responseCount > 0 &&
                  selectedPlatforms &&
                  selectedPlatforms.length > 0 && (
                    <span
                      style={{
                        color: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <strong
                        style={{ color: "#024CAA", alignItems: "center" }}
                      >
                        Platforms: 
                      </strong>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {Array.isArray(selectedPlatforms) &&
                          selectedPlatforms.map((e) => {
                            switch (e.value) {
                              case "FACEBOOK":
                                return (
                                  <FontAwesomeIcon
                                    key={e.value}
                                    icon={faSquareFacebook}
                                    style={{
                                      fontSize: "20px",
                                      color: "#4267B2", // Facebook blue
                                      backgroundColor: "#FFFBF5", // Light blue background for the circle
                                      borderRadius: "50%", // Makes it circular
                                      padding: "5px", // Padding inside the circle to adjust icon placement
                                      paddingLeft: "7px", // Horizontal padding (left)
                                      paddingRight: "7px", // Horizontal padding (right)
                                      margin: "5px", // Space between icons
                                    }}
                                    title="Facebook"
                                  />
                                );
                              case "TWITTER":
                                return (
                                  <FontAwesomeIcon
                                    key={e.value}
                                    icon={faSquareXTwitter}
                                    style={{
                                      fontSize: "20px",
                                      color: "black", // Twitter blue
                                      backgroundColor: "#FFFBF5", // Light blue background for the circle
                                      borderRadius: "50%", // Makes it circular
                                      padding: "5px", // Padding inside the circle to adjust icon placement
                                      paddingLeft: "7px", // Horizontal padding (left)
                                      paddingRight: "7px", // Horizontal padding (right)
                                      margin: "5px", // Space between icons
                                    }}
                                    title="Twitter"
                                  />
                                );
                              case "YOUTUBE":
                                return (
                                  <FontAwesomeIcon
                                    key={e.value}
                                    icon={faYoutube}
                                    style={{
                                      fontSize: "20px",
                                      color: "#FF0000", // YouTube red
                                      backgroundColor: "#FFFBF5", // Light red background for the circle
                                      borderRadius: "50%", // Makes it circular
                                      padding: "5px", // Padding inside the circle to adjust icon placement
                                      margin: "5px", // Space between icons
                                    }}
                                    title="YouTube"
                                  />
                                );
                              case "THREADS":
                                return (
                                  <FontAwesomeIcon
                                    icon={faSquareThreads}
                                    style={{
                                      fontSize: "20px",
                                      color: "black",
                                      backgroundColor: "#FFFBF5",
                                      borderRadius: "50%",
                                      padding: "5px",
                                      paddingLeft: "7px",
                                      paddingRight: "7px",
                                      margin: "5px",
                                    }}
                                    title="Threads"
                                  />
                                );
                              case "REDDIT":
                                return (
                                  <FontAwesomeIcon
                                    key={e.value}
                                    icon={faRedditSquare}
                                    style={{
                                      fontSize: "20px",
                                      color: "#FF4500", // Reddit orange
                                      backgroundColor: "#FFFBF5", // Light background for the circle
                                      borderRadius: "50%", // Makes it circular
                                      padding: "5px", // Padding inside the circle to adjust icon placement
                                      paddingLeft: "7px", // Horizontal padding (left)
                                      paddingRight: "7px", // Horizontal padding (right)
                                      margin: "5px", // Space between icons
                                    }}
                                    title="Reddit"
                                  />
                                );
                              default:
                                return (
                                  <span
                                    key={e.value}
                                    style={{
                                      margin: "0 5px",
                                      color: "rgba(0, 0, 0, 0.7)",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {e.value}
                                  </span>
                                );
                            }
                          })}
                      </div>
                    </span>
                  )}
                {responseCount > 0 &&
                  selectedSections &&
                  selectedSections.length > 0 && (
                    <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                      <strong style={{ color: "#024CAA" }}>Sections: </strong>
                      <strong
                        style={{
                          color: "rgba(0, 0, 0, 0.7)",
                          alignItems: "center",
                        }}
                      >
                        {selectedSections.length}
                      </strong>
                      {/* {selectedSections.map((e) => e.value).join(", ")} */}
                    </span>
                  )}
                {responseCount > 0 &&
                  selectedLanguages &&
                  selectedLanguages.length > 0 && (
                    <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                      <strong style={{ color: "#024CAA" }}>Languages: </strong>
                      {/* {selectedLanguages.map((e) => e.value).join(", ")} */}
                      <strong
                        style={{
                          color: "rgba(0, 0, 0, 0.7)",
                          alignItems: "center",
                        }}
                      >
                        {selectedLanguages.length}
                      </strong>
                    </span>
                  )}

                {responseCount > 0 &&
                  selectedSentiment &&
                  selectedSentiment.length > 0 && (
                    <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                      <strong style={{ color: "#024CAA" }}>Sentiment: </strong>
                      <strong
                        style={{
                          color: "rgba(0, 0, 0, 0.7)",
                          alignItems: "center",
                        }}
                      >
                        {selectedSentiment.map((e) => e.value).join(", ")}
                      </strong>
                    </span>
                  )}

                {responseCount > 0 &&
                  selectedIntensity &&
                  selectedIntensity.length > 0 && (
                    <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                      <strong style={{ color: "#024CAA" }}>Intensity: </strong>
                      <strong
                        style={{
                          color: "rgba(0, 0, 0, 0.7)",
                          alignItems: "center",
                        }}
                      >
                        {selectedIntensity.map((e) => e.value).join(", ")}
                      </strong>
                    </span>
                  )}
                {responseCount > 0 &&
                  selectedContent &&
                  selectedContent.length > 0 && (
                    <span style={{ color: "rgba(0, 0, 0, 0.7)" }}>
                      <strong style={{ color: "#024CAA" }}>
                        Content Type: 
                      </strong>
                      <strong
                        style={{
                          color: "rgba(0, 0, 0, 0.7)",
                          alignItems: "center",
                        }}
                      >
                        {selectedContent.map((e) => e.value).join(", ")}
                      </strong>
                    </span>
                  )}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          id="printeablediv"
          className="report-table-container"
          ref={tableRef}
          style={{ padding: "0px" }}
        >
          {loading ? (
            <div
              className="three-body-problem"
              style={{
                height: "80vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="three-body">
                <div className="three-body__dot"></div>
                <div className="three-body__dot"></div>
                <div className="three-body__dot"></div>
              </div>
            </div>
          ) : serverresponse && serverresponse.length > 0 ? (
            applyValue &&
            applyValue === "api/filter" &&
            serverresponse.length > 0 ? (
              <TextAnalysisTable analysisData={serverresponse} />
            ) : applyValue &&
              applyValue === "api/images" &&
              serverresponse.length > 0 ? (
              <ImageAnalysisTable analysisData={serverresponse} />
            ) : applyValue &&
              applyValue === "api/socialSentiments" &&
              serverresponse.length > 0 ? (
              <SentimentAnalysisTable analysisData={serverresponse} />
            ) : applyValue &&
              applyValue === "news/report" &&
              serverresponse.some((item) =>
                Object.values(item).some(
                  (value) => value !== null && value !== "N/A" && value !== ""
                )
              ) ? (
              <TextAnalysisTableNews analysisData={serverresponse} />
            ) : (
              <div
                style={{
                  width: "160vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={nodata}
                  alt="No Data"
                  style={{
                    width: "75vh",
                  }}
                />
              </div>
            )
          ) : (
            <div
              style={{
                width: "160vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={nodata}
                alt="No Data"
                style={{
                  width: "75vh",
                }}
              />
            </div>
          )}
        </div>
      </main>
      <ReactProSidebar />
    </>
  );
};

export default ReportNav;
